import { keys } from "@prismicio/editor-support/Object"
import { HeaderTabLink } from "@prismicio/editor-ui"
import { Suspense, useState } from "react"
import { Link } from "react-router-dom"

import { getBaseRepositoryUrl, getRepositoryName } from "../../app/routing"
import { useRepositoryV2 } from "../../app/services/repository"
import { SettingsPage } from "../SettingsPage"
import { SettingsPageBodyHeader } from "../SettingsPageBodyHeader"
import { SettingsPageBodyTabs } from "../SettingsPageBodyTabs"
import { ApiAndBandwidthTabContent } from "./ApiAndBandwidthTabContent"

export function UsagePage() {
  const [activeTabKey, setActiveTabKey] =
    useState<keyof typeof usagePageTabs>("api-and-bandwidth")

  const ActiveTabContent = usagePageTabs[activeTabKey].Content

  return (
    <SettingsPage pageName="Usage">
      <SettingsPageBodyHeader
        title="Usage dashboard"
        description="The overall bandwidth of content being requested by a website through servers or clients."
      />
      <SettingsPageBodyTabs>
        {keys(usagePageTabs).map((tabKey) => (
          <HeaderTabLink
            key={tabKey}
            text={usagePageTabs[tabKey].triggerText}
            onClick={() => {
              setActiveTabKey(tabKey)
            }}
            selected={tabKey === activeTabKey}
          />
        ))}
        <Suspense>
          <IntegrationFieldsTabTrigger />
        </Suspense>
      </SettingsPageBodyTabs>
      <ActiveTabContent />
    </SettingsPage>
  )
}

const usagePageTabs = {
  "api-and-bandwidth": {
    triggerText: "API & Bandwidth",
    Content: ApiAndBandwidthTabContent,
  },
}

function IntegrationFieldsTabTrigger() {
  const { data: repository } = useRepositoryV2()
  if (!repository?.quotas.integrationFieldsEnabled) return null

  const repositoryId = getRepositoryName()
  const baseRepoUrl = getBaseRepositoryUrl(repositoryId)

  return (
    <HeaderTabLink
      text="Integration fields"
      renderLink={(children) => (
        <Link to={`${baseRepoUrl}/settings/usage`}>{children}</Link>
      )}
      selected={false}
    />
  )
}
